import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { ProductModel } from '../Model/ProductModel';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {
  prod: ProductModel | any;
  ProductList: AngularFireList<ProductModel>;
  Products: ProductModel[] = [];
  constructor(db: AngularFireDatabase, private route: ActivatedRoute) { 
    var Product: ProductModel | any = null;
    let name = this.route.snapshot.paramMap.get('Name')
    this.ProductList = db.list('Products');
    this.ProductList.valueChanges().subscribe(products =>{
      for(var i=0; i<products.length; i++)
      {
          if(products[i].Name == name)
          {
            this.prod = products[i];
          }
      }
      
    });
    
  }

  ngOnInit(): void {
     

  }

}
